import { render, staticRenderFns } from "./AccountingBooks.vue?vue&type=template&id=5c2278f6&"
import script from "./AccountingBooks.vue?vue&type=script&lang=js&"
export * from "./AccountingBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports